import React, { Component, PropTypes } from 'react';
import ReactLoader from 'react-loader';
import { connect } from 'react-redux';

const options = {
  lines: 0,
  length: 0,
  width: 0,
  radius: 0,
  corners: 1,
  rotate: 0,
  direction: 1,
  color: '#000',
  speed: 1,
  trail: 60,
  shadow: false,
  hwaccel: false,
  zIndex: 2e9,
  top: '50%',
  left: '50%',
  scale: 1.0,
};

const mapStateToProps = state => ({
  unfinishedRequests: state.loader.unfinishedRequests,
});

class Loader extends Component {
  static propTypes = {
    unfinishedRequests: PropTypes.array,
  };

  render() {
    const { unfinishedRequests } = this.props;

    return (
      <ReactLoader loaded={unfinishedRequests.length === 0} options={options} className="loader" />
    );
  }
}

export default connect(mapStateToProps)(Loader)


// WEBPACK FOOTER //
// ./src/components/loader/Loader.js